import { IPayloadDelete } from '~/utils/interface/customer';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { ICampaign, IParamsGetCampaign, IResponseGetCampaign } from '~/utils/interface/campaign';

const url = `api/admin/campaigns`;

const campaignApi = {
  getList(params: IParamsGetCampaign) {
    return axiosClient.get<IApiBaseResponse<IResponseGetCampaign>>(`api/admin/campaigns`, { params });
  },
  create(data: ICampaign) {
    return axiosClient.post<IApiBaseResponse<ICampaign>>(url, data);
  },
  getDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<ICampaign>>(`api/admin/campaigns/${id}`);
  },
  update(id: string | undefined, data: ICampaign) {
    return axiosClient.put<IApiBaseResponse<ICampaign>>(`api/admin/campaigns/${id}`, data);
  },
  delete(data: IPayloadDelete) {
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
};

export default campaignApi;
